import { useState } from "react";

export default function PostActions({ title }: { title: string }) {
  const [liked, setLiked] = useState(false);
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3 py-4 border-y border-background-200">
      <button
        type="button"
        onClick={() => setLiked((v) => !v)}
        aria-pressed={liked}
        className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-md text-sm font-medium border transition-colors cursor-pointer whitespace-nowrap ${
          liked
            ? "bg-accent-100 text-accent-800 border-accent-300"
            : "bg-background-50 text-foreground-700 border-background-300 hover:border-accent-300"
        }`}
      >
        <i className={liked ? "ri-heart-3-fill" : "ri-heart-3-line"} aria-hidden="true"></i>
        {liked ? "已点赞" : "觉得很瓜"}
      </button>
      <button
        type="button"
        onClick={() => setSaved((v) => !v)}
        aria-pressed={saved}
        className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-md text-sm font-medium border transition-colors cursor-pointer whitespace-nowrap ${
          saved
            ? "bg-secondary-100 text-secondary-900 border-secondary-300"
            : "bg-background-50 text-foreground-700 border-background-300 hover:border-secondary-300"
        }`}
      >
        <i className={saved ? "ri-bookmark-fill" : "ri-bookmark-line"} aria-hidden="true"></i>
        {saved ? "已收藏" : "收藏话题"}
      </button>
      <button
        type="button"
        onClick={handleCopy}
        className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-md text-sm font-medium border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className={copied ? "ri-check-line" : "ri-link"} aria-hidden="true"></i>
        {copied ? "链接已复制" : "复制链接"}
      </button>
      <span className="text-xs text-foreground-500 ml-auto hidden sm:block truncate max-w-[220px]">
        分享话题：{title}
      </span>
    </div>
  );
}